import calcCharacteristicValues from '../helpers/calcCharacteristicValues'
import calcAbilities from '../helpers/calcAbilities'
import calcGeneralDetails from '../helpers/calcGeneralDetails'
import calcCurrentAbility from '../helpers/calcCurrentAbility'
import calcSkillValues from '../helpers/calcSkillValues'
import store from '../store/index'
//----------------------------------
// process reset totals reason adjs
//----------------------------------
export default function processResetTotalsReasonAdjs({ payload = {}, character = null }) {
  //-----------
  // get parms
  //-----------
  const category = payload.category ? payload.category : ''
  const type = payload.type ? payload.type : ''
  const adjs = payload.data ? payload.data : {}

  if (!character) {
    return null
  }
  //-------------------
  // get config values
  //-------------------
  const config = store.getters['combat/getConfig']
  const max_skill = config ? config.max_skill : 100
  const min_ca = config ? config.min_ca : 1
  const max_ca = config ? config.max_ca : 5
  const min_cr = config ? config.min_cr : 1
  const max_cr = config ? config.max_cr : 5
  //===================================================================================================
  // A. where category = SKILLS
  //===================================================================================================
  if (category == 'skill') {
    //---------------------------------------------
    // get matching skill(s) for type (skill name)  [normally only one but could be multiple is runecasting]
    //--------------------------------------------------------------
    // if type includes 'Rune' then map to 'Runecasting' skill name
    //--------------------------------------------------------------
    const matching_skills = character.skills.filter(
      (s) => s.name === type || (type.includes('Rune') && s.display_name === type),
    )
    //---------------------
    // got matching skills
    //---------------------
    if (matching_skills && matching_skills.length > 0) {
      //--------------------
      // loop matching skills
      //---------------------
      matching_skills.forEach((skill) => {
        //--------------------------
        // update skill adjs totals
        //--------------------------
        skill = _updateSkillAdjTots({ category, type, skill, character })
        //---------------------------
        // update skill adjs reasons
        //---------------------------
        skill = _updateSkillAdjReasons({ category, type, skill })
        //--------------------------------------------------------
        // recalc current skill (plus other skill-related values)
        //--------------------------------------------------------
        skill = _recalcSkillValues({ type, skill, character, max_skill })
        //-------------------------------------------
        // trigger Vue reactivity with new array ref
        // -------------------------------------------
        let idx = character.skills.findIndex((s) => s.id === skill.id)
        if (idx !== -1) {
          character.skills[idx] = skill
        }
      })
    }
    //=====================================================================
    // B. where NON-SKILL category
    //=====================================================================
  } else {
    //-------------------------------------
    // update non-skill adjs total/reasons
    //-------------------------------------
    character[`${type}_adjs_tot`] = 0
    character[`${type}_adjs_reasons`] = ''
    //=====================================================================
    // B1. where category = ABILITY
    //=====================================================================
    if (category == 'ability') {
      character = _recalcCurrentAbility({
        type: type,
        character: character,
        min_ca,
        max_ca,
        min_cr,
        max_cr,
      })
      //=====================================================================
      // B2. where category = CHARACTERISTIC
      //=====================================================================
    } else if (category == 'characteristic') {
      character = calcCharacteristicValues({ pfx: type, character: character })
      character = calcAbilities({ pfx: type, character: character })
      character = calcGeneralDetails({ character })
    }
  }
  //--------------------------
  // return mutated character
  //--------------------------
  return character
  //=================================================================================
  // INTERNAL FUNCTION: update skill adjs totals
  // --------------------------------------------
  function _updateSkillAdjTots({ category, type, skill, character }) {
    //----------------------------------------------------------------
    // check if adj props exist - if not, create new object with them
    //----------------------------------------------------------------
    if (!('adjs_tot' in skill)) {
      return {
        ...skill,
        adjs_tot: 0,
        adjs_tot_character_skill: 0,
        adjs_tot_characteristic_skill: 0,
        adjs_tot_integrated_rune_skill: 0,
      }
    }
    //------------------------------
    // update skill with adj totals
    //------------------------------
    skill.adjs_tot = 0
    skill.adjs_tot_character_skill = 0
    skill.adjs_tot_characteristic_skill = 0
    skill.adjs_tot_integrated_rune_skill = 0
    //----------------------
    // return updated skill
    //----------------------
    return skill
  }
  //=================================================================================
  // INTERNAL FUNCTION: update skill adjs reasons
  // ---------------------------------------------
  function _updateSkillAdjReasons({ category, type, skill }) {
    //----------------------------------------------------------------
    // check if adj props exist - if not, create new object with them
    //----------------------------------------------------------------
    if (!('adjs_reasons_character_skill' in skill)) {
      return {
        ...skill,
        adjs_reasons_character_skill: '',
        adjs_reasons_character_skill_opt: '',
        adjs_reasons_characteristic_skill: '',
        adjs_reasons_integrated_rune_skill: '',
      }
    }
    //-------------------------------
    // update skill with adj reasons
    //-------------------------------
    skill.adjs_reasons_character_skill = ''
    skill.adjs_reasons_character_skill_opt = ''
    skill.adjs_reasons_characteristic_skill = ''
    skill.adjs_reasons_integrated_rune_skill = ''
    //----------------------
    // return updated skill
    //----------------------
    return skill
  }
  //=================================================================================
  // INTERNAL FUNCTION: recalculate skill values
  // --------------------------------------------
  function _recalcSkillValues({ type, character, skill, max_skill }) {
    //-------------------
    // calc skill values
    //-------------------
    calcSkillValues({
      skill,
      character,
      max_skill,
    })
    //----------------------
    // return updated skill
    //----------------------
    return skill
  }
  //=================================================================================
  // INTERNAL FUNCTION: recalculate current ability
  // -----------------------------------------------
  function _recalcCurrentAbility({ type, character, min_ca, max_ca, min_cr, max_cr }) {
    //---------------------------
    // build dam mod melee (cur)
    //---------------------------
    if (type == 'damage_mod_melee') {
      character.damage_mod_melee_cur = ''
      //---------------------------
      // build dam mod ranged (cur)
      //---------------------------
    } else if (type == 'damage_mod_ranged') {
      character.damage_mod_ranged_cur = ''
      //-----------------------------
      // recalc ca, cr, sr, move, fly
      //------------------------------
    } else {
      //------------------
      // set initial parm
      //------------------
      let parm = {
        base: character[`${type}_base`],
        adjs_tot: 0,
      }
      //------------------------
      // set max where ca or cr
      //------------------------
      if (type == 'ca') {
        parm.max = max_ca
        parm.min = min_ca
      } else if (type == 'cr') {
        parm.max = max_cr
        parm.min = min_cr
      }
      //-------------------------
      // go calc current ability
      //-------------------------
      character[`${type}_cur`] = calcCurrentAbility(parm)
    }
    //--------------------------------------
    // return updated character for clarity
    //--------------------------------------
    return character
  }
}
